import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestWorkOrderRequest } from './WorkOrder.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportWorkOrder(params: QuestWorkOrderRequest) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/WorkOrder`,
    params,
  )) as unknown;

  return result as BlobPart;
}
